import moment from 'moment';
import { PerformancePeriodDTO, TransactionFilters } from './types';
import { ISO_8601_FORMAT } from './helpers/dates';
import { SortBy } from './tabs/Transactions/Transactions.meta';

export const startOfYear = moment()
  .startOf('year')
  .format(ISO_8601_FORMAT);

export const endOfYear = moment()
  .endOf('year')
  .format(ISO_8601_FORMAT);

export const today = moment().format(ISO_8601_FORMAT);

export const yesterday = moment()
  .subtract(1, 'days')
  .format(ISO_8601_FORMAT);

export const defaultPeriod = {
  label: 'YTD',
  value: PerformancePeriodDTO.YTD,
  dates: [startOfYear, yesterday],
};

export const defaultTransactionFilters: TransactionFilters = {
  period: {
    label: 'Last 30 Days',
    value: 0,
    dates: [
      moment()
        .subtract(30, 'days')
        .format(ISO_8601_FORMAT),
      yesterday,
    ],
  },
  sortBy: SortBy.Date,
  sortDesc: true,
  query: '',
};

export const unmanagedGroupId = 'Unmanaged';
